var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',[_c('el-col')],1),_c('report-users-to-cut'),_c('el-dialog',{attrs:{"visible":_vm.showDialog,"title":_vm.dialogTitle,"width":"60%"},on:{"update:visible":function($event){_vm.showDialog=$event}}},[_c('rabbey-table3',{attrs:{"data":_vm.itemsRecord,"columns":_vm.columns}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }